(function () {
  'use strict';

  // ============================================================
  // SPECIAL ORDER CHECKOUT GUARD
  // Disables the Checkout button until the special-order tickbox
  // is ticked, when a special-order item is in the cart.
  // Re-attaches on every cart drawer refresh.
  // ============================================================

  function initSpecialOrderCheck() {
    const checkBoxes = document.querySelectorAll('.special-order-check__box');
    if (!checkBoxes.length) {
      // No special order items in cart - make sure no buttons are stuck disabled
      enableAllCheckoutButtons();
      return;
    }

    checkBoxes.forEach((cb) => {
      // Avoid double-binding by tagging the element
      if (cb.dataset.specialOrderBound === 'true') return;
      cb.dataset.specialOrderBound = 'true';

      cb.addEventListener('change', () => {
        // If any of the boxes are ticked, allow checkout. Multiple boxes can
        // appear if the snippet is rendered in both cart-drawer and cart page.
        const anyTicked = Array.from(document.querySelectorAll('.special-order-check__box'))
          .some(el => el.checked);
        if (anyTicked) {
          enableAllCheckoutButtons();
          // Also sync state across all checkboxes on the page so customer
          // does not need to tick the same thing twice
          document.querySelectorAll('.special-order-check__box').forEach(el => { el.checked = true; });
        } else {
          disableAllCheckoutButtons();
        }
      });
    });

    // Initial state - block checkout until ticked
    const anyTickedNow = Array.from(checkBoxes).some(cb => cb.checked);
    if (anyTickedNow) {
      enableAllCheckoutButtons();
    } else {
      disableAllCheckoutButtons();
    }
  }

  function findCheckoutButtons() {
    return document.querySelectorAll([
      'button[name="checkout"]',
      'input[name="checkout"]',
      'a[href*="/checkout"]',
      '.shopify-payment-button button',
      '.cart__checkout-button',
      '.shopify-payment-button'
    ].join(','));
  }

  function disableAllCheckoutButtons() {
    findCheckoutButtons().forEach((btn) => {
      btn.dataset.specialOrderBlock = 'true';
      btn.setAttribute('aria-disabled', 'true');
      if (btn.tagName === 'BUTTON' || btn.tagName === 'INPUT') {
        btn.disabled = true;
      }
      // For <a> tags, intercept clicks via the listener below
    });
  }

  function enableAllCheckoutButtons() {
    findCheckoutButtons().forEach((btn) => {
      if (btn.dataset.specialOrderBlock === 'true') {
        delete btn.dataset.specialOrderBlock;
        btn.removeAttribute('aria-disabled');
        if (btn.tagName === 'BUTTON' || btn.tagName === 'INPUT') {
          btn.disabled = false;
        }
      }
    });
  }

  // Click guard - intercept clicks on disabled checkout buttons and
  // show the visual warning on the special order tickbox
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-special-order-block="true"]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    const warningEl = document.querySelector('.special-order-check');
    if (warningEl) {
      warningEl.classList.add('is-warning');
      warningEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(() => warningEl.classList.remove('is-warning'), 1200);
    }
  }, true);

  // Run at page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSpecialOrderCheck);
  } else {
    initSpecialOrderCheck();
  }

  // Re-run after cart drawer refresh. Listens for the standard event
  // Dawn dispatches, plus a MutationObserver fallback in case the theme
  // does not dispatch one.
  document.addEventListener('cart:refresh', initSpecialOrderCheck);
  document.addEventListener('cart:rerender', initSpecialOrderCheck);

  const drawerEl = document.querySelector('cart-drawer');
  if (drawerEl) {
    const observer = new MutationObserver((mutations) => {
      for (const m of mutations) {
        if (m.addedNodes.length > 0) {
          initSpecialOrderCheck();
          break;
        }
      }
    });
    observer.observe(drawerEl, { childList: true, subtree: true });
  }
})();
